var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"sortable-th",class:{ 'sortable-th--active': _vm.active },on:{"click":function($event){return _vm.$emit('sort', _vm.sortKey)}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]}),_c('v-icon',{staticClass:"sortable-th-arrow",attrs:{"size":"14"}},[_vm._v(_vm._s(_vm.arrow))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }